// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AccountBalance } from './account-balance';
import { AccountValue } from './account-value';
import { Admin } from './admin';
import { AdminSubType } from './admin-sub-type';
import { AdminTypeHistory } from './admin-type-history';
import { Bonding } from './bonding';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AdminType extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  adminTypeId!: number;
  adminPluralSuffix?: string;
  adminSubTypeId!: number;
  adminSuffix?: string;
  alternateDescription?: string;
  appointeeDescription?: string;
  appointeeLiabilityAccountName?: string;
  appointeesDescription?: string;
  asicapptCode?: string;
  asiccessationCode?: string;
  cessationDescription?: string;
  createdBy!: string;
  createdDate!: Date;
  defaultRecPayBasis?: number;
  description!: string;
  locationId!: number;
  longDescription!: string;
  recPayApptDescription?: string;
  shortDescription?: string;
  subLocationId!: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  accountBalances!: AccountBalance[];
  accountValues!: AccountValue[];
  adminSubType!: AdminSubType;
  adminTypeHistories!: AdminTypeHistory[];
  admins!: Admin[];
  bondingAdminTypes!: Bonding[];
  bondingFromAdminTypes!: Bonding[];
}

